import dayjs from 'dayjs';

import { DATE_FORMAT } from '@constants/constants';

export interface FormatDateForDisplayOptions {
  /** When true, parse with local dayjs (not UTC). Default false — use UTC (typical for API ISO timestamps). */
  parseAsTz?: boolean;
}

/**
 * Formats a date string for display using the app's standard DATE_FORMAT (MM/DD/YYYY).
 * Returns undefined for null, undefined, empty string, or invalid dates.
 *
 * By default parses as UTC (e.g. API ISO timestamps). Date-only strings without an offset are
 * interpreted as UTC midnight. Use `{ parseAsTz: true }` to parse with local dayjs instead
 * (date-only strings use local midnight).
 *
 * @param value - Date string (YYYY-MM-DD, ISO, etc.)
 * @param options - Optional; set `parseAsTz: true` to avoid UTC parsing.
 */
export function formatDateForDisplay(
  value: string | null | undefined,
  options?: FormatDateForDisplayOptions,
): string | undefined {
  if (value == null || value === '') return undefined;
  const d = options?.parseAsTz ? dayjs(value) : dayjs.utc(value);
  return d.isValid() ? d.format(DATE_FORMAT) : undefined;
}
